import { render, staticRenderFns } from "./EmissionsSection.vue?vue&type=template&id=7b79b3ee&scoped=true&"
import script from "./EmissionsSection.vue?vue&type=script&lang=ts&"
export * from "./EmissionsSection.vue?vue&type=script&lang=ts&"
import style0 from "./EmissionsSection.vue?vue&type=style&index=0&id=7b79b3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79b3ee",
  null
  
)

export default component.exports